"use client";
import { filterIconAtom } from "@/hooks/headerHooks";
import {
  isEmptyFilterAtom,
  useCurrentFilters,
} from "@/hooks/useCurrentFilters";
import { useAtom } from "jotai";
import { useEffect } from "react";
import MobileFilter from "@/app/components/common-filter-builder/filter/mobile-filter/MobileFilter";

import { useGetFiltersQuery } from "@/api/AppApi/services/filters";
import { IGetFiltersParams } from "@/api/AppApi/services/filters/interfaces/IGetFilters";

export const queryFiltersParams = (query: any): IGetFiltersParams => ({
  ...(query?.q && { q: query.q }),
  ...(query?.category_id && { category_id: query.category_id }),
  ...(query?.brand_id && { brand_id: query.brand_id }),
  ...(query?.external_id && { external_id: query.external_id }),
});
interface Props {
  productNum: number;
  searchParams: { [key: string]: string };
  category_id?: string | number;
}
const Filter: React.FC<Props> = ({ productNum, category_id, searchParams }) => {
  const { data: filtersData } = useGetFiltersQuery(
    queryFiltersParams({ ...searchParams, category_id }),
  );
  const filters = filtersData?.result;
  const [isEmptyFilter] = useAtom(isEmptyFilterAtom);

  const [, setShowFilterIcon] = useAtom(filterIconAtom);
  useCurrentFilters(filters);
  useEffect(() => {
    setShowFilterIcon(productNum > 0 || !isEmptyFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productNum, isEmptyFilter]);
  return <MobileFilter />;
};

export default Filter;
